import { Grid, TextInput, TextInputProps } from '@mantine/core'

type Props = {
  symbolProps: TextInputProps
  alternateSymbolProps: TextInputProps
  disabled?: boolean
  display: 'row' | 'column'
}

export default function SymbolInput({ symbolProps, alternateSymbolProps, disabled, display }: Props) {
  return (
    <Grid>
      <Grid.Col span={display === 'row' ? 6 : 12}>
        <TextInput
          label="Symbol"
          description="Główny symbol produktu, używany przez producenta"
          placeholder="Na przykład 2705"
          withAsterisk
          disabled={disabled}
          {...symbolProps}
        />
      </Grid.Col>
      <Grid.Col span={display === 'row' ? 6 : 12}>
        <TextInput
          label="Alternatywny symbol"
          description="Opcjonalny dodatkowy symbol używany wewnętrznie"
          placeholder={disabled ? '' : 'Na przykład Weronika'}
          disabled={disabled}
          {...alternateSymbolProps}
        />
      </Grid.Col>
    </Grid>
  )
}
